/**
 * Chan XSS qua URL nguoi dung nhap vao href / window.open.
 * Tra ve '#' neu URL dung scheme nguy hiem (javascript:/data:/vbscript:), ke ca khi
 * chen khoang trang/tab/newline kieu "java\tscript:". URL hop le (http/https/mailto/
 * tel/tuong doi) giu nguyen nen khong lam hong link that. Text thuong React da tu escape.
 */
export const safeHref = (url?: string | null): string => {
  if (!url) return '#';
  const stripped = String(url).replace(/\s+/g, '').toLowerCase();
  if (/^(javascript|data|vbscript):/.test(stripped)) return '#';
  return url;
};
